export interface IUserConfig {
    lastLeaderboard?: string
    lastExpanded?: boolean
    switchMetricAlertShown?: boolean
    mobileQuestionType?: string
}

export interface UserDetail {
    id: number
    name: string
    avatar: string | null
}

export interface UserBasic {
    id: string
    name: string
    email: string
}

export interface User {
    id: string
    derivative_id: string | number
    digest: string | number | boolean
    scorecard_digest: boolean
    groups: Array<any>
    email: string
    phone: string
    pass: string
    confirmpass: string
    usertype_id: string | number
    checked: boolean
    status: string
    name: string
    has_mobile_app: number
    has_mfa_setup: boolean
    sfuserid: string
    ignore_user: boolean
    emailactivate: number
    unverified: string
    email_validated_at: number
    last_login: number
    last_login_type: string
    has_mlp: boolean
}

export const emptyUser: User = {
    id: '',
    name: '',
    email: '',
    phone: '',
    pass: '',
    confirmpass: '',
    usertype_id: '',
    digest: true,
    scorecard_digest: true,
    groups: [],
    last_login: 0,
    last_login_type: '',
    derivative_id: 0,
    checked: false,
    status: '',
    has_mobile_app: 0,
    has_mfa_setup: false,
    sfuserid: '',
    ignore_user: false,
    emailactivate: 0,
    email_validated_at: 0,
    unverified: '',
    has_mlp: true,
}

export interface FrontlineUserVisitStats {
    daily: number
    weekly: number
    monthly: number
}

export interface FrontlineUserSessionDetailRow {
    id: string // userId
    name: string
    role: string
    responses: string
    lastSession: string
    friendlyLastSession: string
    sessions: string
    activeDays: string
    hierarchy: { [field: string]: string }
}
